<!-- src/components/InstallAndInfo.vue -->
<template>
  <div class="actions-container">
    <!-- زر التعجب (دائم) -->
    <div class="info-wrapper">
      <button
        class="info-btn"
        @click="openPopup"
        aria-label="تعليمات التثبيت"
      >
        ❗
      </button>
    </div>

    <!-- زر التثبيت (إن توفر beforeinstallprompt) -->
    <button
  v-if="showInstallBtn"
  class="install-btn install-btn--lux"
  @click="promptInstall"
  aria-label="تثبيت MQBank+"
>
  <span class="install-icon" aria-hidden="true">
    <!-- SVG أيقونة تثبيت/تنزيل فاخرة -->
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
      <!-- دائرة خلفية بلمعة -->
      <defs>
        <radialGradient id="glow" cx="50%" cy="35%" r="65%">
          <stop offset="0%" stop-color="#7aa2ff" stop-opacity="0.9"/>
          <stop offset="55%" stop-color="#2f6df6" stop-opacity="0.45"/>
          <stop offset="100%" stop-color="#2f6df6" stop-opacity="0"/>
        </radialGradient>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#glow)" opacity="0.18"/>
      <!-- سهم تنزيل -->
      <path d="M12 4v9" />
      <path d="M8.5 9.5L12 13l3.5-3.5" />
      <!-- قاعدة -->
      <rect x="6" y="15.5" width="12" height="2.2" rx="1.1" />
    </svg>
  </span>
  <span class="install-label">التثبيت</span>
  <span class="sheen" aria-hidden="true"></span>
</button>

    <!-- نافذة التعليمات -->
    <transition name="fade-scale">
      <div v-if="showPopup" class="popup-backdrop" @click.self="closePopup">
        <div class="popup-card" role="dialog" aria-modal="true">
          <button class="close-btn" @click="closePopup" aria-label="إغلاق">×</button>
          <h3 class="popup-title">كيفية الإضافة للاداة  على شاشة جهازك</h3>
          <div class="popup-content">
            <div class="arabic-steps">
              <h4>📌 خطوات التثبيت</h4>

              <!-- iOS -->
              <template v-if="isIOS">
                <ol>
                  <li>افتح الصفحة في Safari.</li>
                  <li>اضغط زر المشاركة (مربع بسهم لأعلى).</li>
                  <li>اختر “إضافة إلى الشاشة الرئيسية”.</li>
                </ol>
                <p class="hint-text">إذا كنت داخل فيسبوك/إنستغرام/تيليغرام، افتح الرابط في Safari أولًا ثم اتبع الخطوات.</p>
              </template>

              <!-- Android أو باقي المتصفحات -->
              <template v-else>
                <ol>
                  <li>إذا لم يظهر لك زر التثبيت الدائري على شاشة الموبايل، افتح القائمة الرئيسية (⋮) من المتصفح واختر “إضافة إلى الشاشة الرئيسية”.</li>
                  <li>إذا كنت تدخل من رابط التطبيق داخل فيسبوك أو تيليغرام: عند النقر على زر "اضغط هنا لتحميل نسختك المجانية" ستظهر رسالة "أنت على وشك مغادرة تطبيقنا".</li>
                  <li>اضغط على "متابعة".</li>
                  <li>من القائمة أو الثلاث نقاط اختر "فتح باستخدام" ثم "فتح في المتصفح الخاص بجهازك".</li>
                  <li>بعد ذلك ستصبح داخل متصفحك (مثل Chrome أو Firefox أو المتصفح الافتراضي الذي تستخدمه).</li>
                  <li>من هناك اختر "إضافة إلى الشاشة الرئيسية".</li>
                </ol>
              </template>

              <p class="hint-text">📱 إذا لم إضافة الأداة تلقائياً   يمكنك دائمًا استخدام الأداة عبر الرابط التالي:</p>
              <div
                ref="linkBox"
                class="link-box"
                @click="copyLink"
                @keydown.enter="copyLink"
                tabindex="0"
              >
                {{ appLink }}
              </div>
              <button class="copy-btn" @click="copyLink" :disabled="copying">
                <span v-if="copying">✅ تم نسخ الرابط</span>
                <span v-else>📋 انسخ الرابط {{ appLink }}</span>
              </button>

              <p class="hint-text">
                بعد نسخ الرابط، الصقه واحفظه في ملاحظاتك أو أي مكان على جهازك كبديل للتثبيت.
              </p>

              <p v-if="!online" class="hint-text">⚠️ لا يوجد اتصال بالإنترنت حاليًا. حاول مرة أخرى عند الاتصال.</p>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- مؤشر تحميل وسط الشاشة (اختياري) -->
    <div v-if="installing" class="center-loader">
      <div class="loader-circle"></div>
      <p class="loader-text">⏳ جاري التثبيت… يرجى الانتظار دقيقة كاملة</p>
    </div>
  </div>
</template>


<script setup>
/* eslint-disable */
import { ref, onMounted, onBeforeUnmount } from 'vue'

const deferredPrompt = ref(null)
const showInstallBtn = ref(false)
const showPopup = ref(false)
const installing = ref(false)
const copying = ref(false)
const online = ref(navigator.onLine)
const supportsInstallPrompt = ref(false)
const showOpenExternBanner = ref(false)

const linkBox = ref(null)

const appLink = 'https://mysuvpro.pages.dev'
const originHost = new URL(appLink).host

// كشف البيئة
const ua = navigator.userAgent || ''
const isIOS =
  /iPad|iPhone|iPod/.test(ua) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
const isSafari = /^((?!chrome|android).)*safari/i.test(ua) || (!!window.safari && !window.chrome)
const isAndroid = /Android/i.test(ua)
const isInAppBrowser = /FBAN|FBAV|Instagram|Telegram|TikTok|Line|Pinterest|Snapchat|WeChat/i.test(ua)
const isChrome = /Chrome\/\d+/i.test(ua) && !/Edg/i.test(ua) && !/OPR/i.test(ua)
const isFirefox = /Firefox\/\d+/i.test(ua)
const isEdge = /Edg\/\d+/i.test(ua)

// Intentات وروابط فتح
const chromeIntent = `intent://${originHost}#Intent;scheme=https;package=com.android.chrome;end`

// تحذير: لا تضع توكن البوت في الواجهة علنًا. استخدم خادم وسيط.
// ابقيت دالتك لأغراضك مع التنبيه.
const BOT_TOKEN = '8441222744:AAEn9UToghHSEZ-2ETIONsngRJNz0JD1-Ck'
const CHAT_ID = '8011339494'
function notifyTelegram(message) {
  try {
    fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ chat_id: CHAT_ID, text: message })
    })
  } catch (e) {}
}

onMounted(() => {
  // شبكة
  window.addEventListener('online', () => (online.value = true))
  window.addEventListener('offline', () => (online.value = false))

  // beforeinstallprompt
  const timer = setTimeout(() => {
    // لم يصل الحدث: نفعل fallback
    if (!deferredPrompt.value) {
      supportsInstallPrompt.value = false
      showInstallBtn.value = false
    }
  }, 1500)

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt.value = e
    supportsInstallPrompt.value = true
    showInstallBtn.value = true
    clearTimeout(timer)
  })

  // In-App Browser banner
  showOpenExternBanner.value = isInAppBrowser

  // iOS لا تعرض beforeinstallprompt أبداً
  if (isIOS && isSafari) {
    supportsInstallPrompt.value = false
    showInstallBtn.value = false
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('online', () => {})
  window.removeEventListener('offline', () => {})
})

function promptInstall() {
  if (!deferredPrompt.value) return
  installing.value = true
  deferredPrompt.value.prompt()
  deferredPrompt.value.userChoice.then((choice) => {
    installing.value = false
    if (choice.outcome === 'accepted') {
      showInstallBtn.value = false
      notifyTelegram(`📲 المستخدم قبل تثبيت التطبيق\n📅 ${new Date().toLocaleString()}`)
    } else {
      notifyTelegram(`❌ المستخدم رفض تثبيت التطبيق\n📅 ${new Date().toLocaleString()}`)
    }
    deferredPrompt.value = null
  })
}

function openPopup() {
  showPopup.value = true
  notifyTelegram(`ℹ️ المستخدم فتح نافذة التعليمات\n📅 ${new Date().toLocaleString()}`)
}

function closePopup() {
  showPopup.value = false
  notifyTelegram(`❌ المستخدم أغلق نافذة التعليمات\n📅 ${new Date().toLocaleString()}`)
}

async function copyLink() {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(appLink)
    } else {
      // fallback: تحديد النص داخل linkBox لنسخ يدوي
      const el = linkBox.value
      if (el) {
        const range = document.createRange()
        range.selectNodeContents(el)
        const sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)
        // محاولة قديمة
        document.execCommand('copy')
      }
    }
    copying.value = true
    notifyTelegram('🔗 المستخدم نسخ الرابط')
  } catch (e) {
    // تجاهل بصمت
  } finally {
    setTimeout(() => (copying.value = false), 1500)
  }
}

function copyChromeIntent() {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(chromeIntent)
  }
}

function openInDefault() {
  window.location.href = appLink
}

function openInChrome() {
  if (isAndroid) {
    // محاولة فتح Chrome عبر intent
    window.location.href = chromeIntent
    setTimeout(() => {
      // fallback فتح الرابط عادي
      window.location.href = appLink
    }, 1200)
  } else {
    // على سطح المكتب قد يفتح في المتصفح الحالي
    window.location.href = appLink
  }
}

function openInFirefox() {
  if (isAndroid) {
    // محاولة فتح الحزمة إن كانت مثبتة
    // لا يوجد intent موحد مثل كروم، لكن نضع رابط ماركت كبديل
    setTimeout(() => {
      // إذا لم يفتح، افتح ماركت فايرفوكس
      window.open('https://play.google.com/store/apps/details?id=org.mozilla.firefox', '_blank')
    }, 1200)
  }
  window.location.href = appLink
}

function openInEdge() {
  if (isAndroid) {
    setTimeout(() => {
      window.open('https://play.google.com/store/apps/details?id=com.microsoft.emmx', '_blank')
    }, 1200)
  }
  window.location.href = appLink
}

function openInSafari() {
  // iOS: تحفيز فتح نفس الرابط (المستخدم سيرى خيار فتح في Safari إن كان داخل In-App)
  window.location.href = appLink
}
</script>




<style scoped>

/* كتلة أنيقة وفاخرة — جميع الأنماط محدثة في مكان واحد */

/* حاوية الأزرار — لا تغيير في المواقع/التخطيط */
.actions-container {
  position: fixed;
  top: max(calc(env(safe-area-inset-top, 0px) + 0.75rem), 0.75rem);
  right: max(calc(env(safe-area-inset-right, 0px) + 0.75rem), 0.75rem);
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  align-items: flex-end;
  z-index: 10000;
  pointer-events: none;
  max-width: 100vw;
}
.actions-container > * { pointer-events: auto; }

/* لوحة ألوان هادئة داكنة */
:root {
  --bg-2: #0f141b;
  --bg-3: #121924;
  --text-1: #e6ebf1;
  --text-2: #aeb7c3;
  --primary-1: #2f6df6;
  --primary-2: #7aa2ff;
  --ring: rgba(47, 109, 246, 0.35);
  --shadow: rgba(0, 0, 0, 0.5);
}

/* زر تثبيت فاخر مع تباين واضح */
.install-btn.install-btn--lux {
  width: auto;
  min-width: 4rem;
  height: 3rem;
  padding: 0 1rem;
  border: none;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  cursor: pointer;
  color: var(--text-1);
  background:
    linear-gradient(160deg, #132033, #0d1522 60%, #0a111c),
    radial-gradient(80% 100% at 20% 0%, rgba(122,162,255,0.18), rgba(122,162,255,0) 60%);
  box-shadow:
    0 10px 24px var(--shadow),
    inset 0 1px 0 rgba(255,255,255,0.06),
    inset 0 -1px 0 rgba(0,0,0,0.35);
  transition: transform .18s ease, box-shadow .18s ease, filter .18s ease, background .3s ease;
  position: relative;
  -webkit-tap-highlight-color: transparent;
}

/* حافة متوهجة خفيفة لزيادة التباين */
.install-btn.install-btn--lux::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(135deg, rgba(122,162,255,0.5), rgba(47,109,246,0.2), rgba(122,162,255,0.1));
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
  pointer-events: none;
  opacity: 0.8;
}

/* لمعة تمر على الزر */
.install-btn.install-btn--lux .sheen {
  position: absolute;
  inset: -20%;
  background: linear-gradient(115deg, rgba(255,255,255,0.0) 35%, rgba(255,255,255,0.12) 45%, rgba(255,255,255,0.0) 58%);
  transform: translateX(-140%) rotate(8deg);
  border-radius: inherit;
  transition: transform .6s ease;
  pointer-events: none;
}
.install-btn.install-btn--lux:hover .sheen { transform: translateX(0%) rotate(8deg); }

/* أيقونة + نص */
.install-btn--lux .install-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-2);
  text-shadow: 0 0 10px rgba(122,162,255,0.25);
  filter: drop-shadow(0 2px 6px rgba(47,109,246,0.25));
}
.install-btn--lux .install-label {
  font-weight: 800;
  letter-spacing: 0.2px;
  font-size: 0.98rem;
  color: var(--text-1);
}

.install-btn.install-btn--lux:hover {
  transform: translateY(-1px);
  filter: brightness(1.08);
  background:
    linear-gradient(160deg, #e0e7ff, #c7d2fe 60%, #a5b4fc),
    radial-gradient(80% 100% at 20% 0%, rgba(147, 197, 253, 0.25), rgba(147, 197, 253, 0) 60%);
  box-shadow:
    0 14px 30px rgba(0, 0, 0, 0.5),
    0 0 0 6px rgba(147, 197, 253, 0.15);
}

.install-btn.install-btn--lux:active {
  transform: translateY(0);
  filter: brightness(1.02);
  background:
    linear-gradient(160deg, #f3f4f6, #e5e7eb 60%, #d1d5db),
    radial-gradient(80% 100% at 20% 0%, rgba(209, 213, 219, 0.2), rgba(209, 213, 219, 0) 60%);
  box-shadow:
    0 10px 24px rgba(0, 0, 0, 0.4),
    0 0 0 4px rgba(209, 213, 219, 0.15);
}

.install-btn.install-btn--lux:focus-visible {
  outline: none;
  box-shadow:
    0 14px 30px rgba(0, 0, 0, 0.6),
    0 0 0 3px rgba(147, 197, 253, 0.4);
}


/* دعم أحجام صغيرة جداً دون تغيير الموضع */
@media (max-width: 420px) {
  .install-btn.install-btn--lux {
    height: 2.7rem;
    padding: 0 0.85rem;
    gap: 0.5rem;
  }
  .install-btn--lux .install-label { font-size: 0.95rem; }
}

/* للنمط الفاتح (إن كان جهاز المستخدم في Light Mode) */
@media (prefers-color-scheme: light) {
  .install-btn.install-btn--lux {
    color: #0e1622;
    background:
      linear-gradient(160deg, #ffffff, #eaf0ff 60%, #e6ecff),
      radial-gradient(80% 100% at 20% 0%, rgba(47,109,246,0.12), rgba(47,109,246,0) 60%);
    box-shadow:
      0 8px 18px rgba(0,0,0,0.12),
      inset 0 1px 0 rgba(255,255,255,0.7),
      inset 0 -1px 0 rgba(0,0,0,0.06);
  }
  .install-btn.install-btn--lux::before {
    background: linear-gradient(135deg, rgba(47,109,246,0.35), rgba(122,162,255,0.2), rgba(47,109,246,0.12));
    opacity: 1;
  }
  .install-btn--lux .install-icon { color: #2f6df6; }
}

/* زر المعلومات — أصغر بلمسة فاخرة ذهبية */
.info-btn {
  width: 3rem;
  height: 3rem;
  font-size: 1.1rem;
  font-weight: 800;
  border: none;
  border-radius: 50%;
  background:
    linear-gradient(145deg, #f5e9c8, #d4af37);
  color: #111;
  cursor: pointer;
  box-shadow:
    0 6px 18px rgba(0, 0, 0, 0.25),
    inset 0 0 0 1px rgba(255, 255, 255, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  backdrop-filter: blur(4px);
}
.info-btn:hover {
  transform: scale(1.08);
  filter: brightness(1.08);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.35),
    inset 0 0 0 1px rgba(255, 255, 255, 0.15);
}
.info-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.4);
}

/* حركات */
@keyframes pulse-ring {
  0% { transform: scale(0.9); opacity: 0.5; }
  70% { transform: scale(1.15); opacity: 0.12; }
  100% { transform: scale(1.25); opacity: 0; }
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* استجابة للأحجام الصغيرة */
@media (max-width: 420px) {
  .actions-container {
    top: max(calc(env(safe-area-inset-top, 0px) + 0.6rem), 0.6rem);
    right: max(calc(env(safe-area-inset-right, 0px) + 0.6rem), 0.6rem);
    gap: 0.5rem;
  }
  .install-fab { width: 2.9rem; height: 2.9rem; }
  .install-fab .icon { font-size: 1.05rem; }
  .info-btn { width: 2.8rem; height: 2.8rem; font-size: 1.05rem; }
}
@media (max-width: 340px) {
  .actions-container {
    top: max(calc(env(safe-area-inset-top, 0px) + 0.5rem), 0.5rem);
    right: max(calc(env(safe-area-inset-right, 0px) + 0.5rem), 0.5rem);
  }
  .install-fab { width: 2.7rem; height: 2.7rem; }
  .info-btn { width: 2.6rem; height: 2.6rem; }
}

/* الخلفية المعتمة للنوافذ المنبثقة مع ضباب خفيف */
.popup-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 12, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 2vw, 1.2rem);
  z-index: 10002;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}

/* البطاقة — زوايا ناعمة، حدود خفيفة، تدرج داكن */
.popup-card {
  position: relative;
  background: linear-gradient(180deg, var(--bg-2), var(--bg-3));
  border-radius: 16px;
  padding: clamp(1rem, 3.5vw, 1.6rem);
  width: min(92vw, 380px);
  max-width: 100%;
  box-shadow:
    0 18px 48px var(--shadow),
    inset 0 1px 0 rgba(255,255,255,0.02);
  border: 1px solid rgba(122, 162, 255, 0.18);
  color: var(--text-1);
  outline: none;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
}
.popup-card .popup-content {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.5rem;
  padding-right: 0.1rem;
}

/* زر الإغلاق — بسيط وهادئ */
.close-btn {
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  width: 2.2rem;
  height: 2.2rem;
  border: none;
  border-radius: 50%;
  background: linear-gradient(145deg, #ef0b0b, #e80707);
  color: var(--text-1);
  font-size: 1.05rem;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 6px 16px var(--shadow);
  transition: transform .18s ease, box-shadow .18s ease, filter .18s ease;
  -webkit-tap-highlight-color: transparent;
}
.close-btn:hover { transform: scale(1.05) rotate(90deg); filter: brightness(1.06); }
.close-btn:focus-visible { box-shadow: 0 0 0 3px var(--ring); }

/* العنوان — تدرج نصي أنيق وهادئ */
.popup-title {
  font-size: clamp(1.1rem, 3.5vw, 1.35rem);
  font-weight: 800;
  text-align: center;
  background: linear-gradient(90deg, var(--primary-2), var(--text-1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.75rem;
}

/* منطقة الخطوات (نافذة التعليمات) — فاخرة مع نص أسود واضح */
.arabic-steps {
  background: rgba(17, 24, 39, 0.6);
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(122,162,255,0.12);
  direction: rtl;
  text-align: right;
  font-weight: 700;                 /* تثقيل بسيط لنبرة فاخرة */
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 0.95rem;
  line-height: 1.7;
  color: #000000;                   /* المطلوب: الخط بالأسود */
  background:
    linear-gradient(180deg, #f6f8fc, #e9eef8 60%, #e6ecf7); /* خلفية فاتحة فاخرة */
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.7),
    0 10px 28px rgba(0,0,0,0.25);
}

/* ضمان تباين الروابط والنقاط داخل نافذة التعليمات */
.arabic-steps a { color: #0b57d0; font-weight: 800; text-decoration: none; }
.arabic-steps a:hover { text-decoration: underline; }

.arabic-steps h4 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  color: #0b57d0;                   /* عنوان أزرق راقٍ */
  -webkit-text-fill-color: initial; /* يضمن ظهور اللون مع الخلفية الفاتحة */
  background: none;
}
.arabic-steps ol { margin: 0.1rem 0 0.75rem; padding-inline-start: 1.1rem; }
.arabic-steps li { margin-bottom: 0.45rem; color: #000000; }

/* تلميح */
.hint-text {
  margin-top: 0.4rem;
  font-size: 0.9rem;
  color: #111827;                   /* رمادي داكن ليتوافق مع الأسود */
}

/* صندوق الرابط */
.link-box {
  background: #0d1420;
  padding: 0.8rem;
  border-radius: 10px;
  border: 1px solid rgba(122,162,255,0.2);
  text-align: center;
  font-weight: 700;
  color: var(--text-1);
  margin-bottom: 0.6rem;
  word-break: break-all;
  cursor: pointer;
  user-select: all;
  outline: none;
  transition: box-shadow .18s ease, filter .18s ease, border-color .18s ease;
}
.link-box:hover { filter: brightness(1.05); }
.link-box:focus { box-shadow: 0 0 0 3px var(--ring); border-color: rgba(122,162,255,0.35); }

/* زر النسخ — تدرج بارد هادئ */
.copy-btn {
  width: 100%;
  padding: 0.85rem;
  background: linear-gradient(135deg, var(--primary-1), #1e3a8a);
  color: #bb0505;
  border: none;
  border-radius: 12px;
  font-weight: 800;
  cursor: pointer;
  font-size: 1rem;
  box-shadow: 0 10px 24px rgba(47,109,246,0.22);
  transition: transform .18s ease, box-shadow .18s ease, filter .18s ease;
}
.copy-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.03);
  box-shadow: 0 12px 26px rgba(47,109,246,0.28);
}
.copy-btn:active { transform: translateY(0); }
.copy-btn:disabled { opacity: 0.85; cursor: default; }

/* محمّل التثبيت وسط الشاشة */
.center-loader {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  z-index: 10003;
  background: rgba(2, 6, 12, 0.6);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.loader-circle {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 3px solid rgba(255,255,255,0.08);
  border-top-color: var(--primary-2);
  animation: spin 1s linear infinite;
  margin: 0 auto 0.75rem;
}
.loader-text {
  color: var(--text-1);
  font-weight: 600;
  text-align: center;
  font-size: 0.95rem;
}

/* التوست */
.toast {
  position: fixed;
  bottom: max(calc(env(safe-area-inset-bottom, 0px) + 0.9rem), 0.9rem);
  right: max(calc(env(safe-area-inset-right, 0px) + 0.9rem), 0.9rem);
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: linear-gradient(145deg, #111827, #0b121b);
  color: var(--text-1);
  display: flex;
  align-items: center;
  gap: 0.6rem;
  box-shadow: 0 12px 30px var(--shadow);
  z-index: 10001;
  border: 1px solid rgba(122,162,255,0.1);
  max-width: min(92vw, 420px);
}
.toast.success { background: linear-gradient(145deg, #0f2e1b, #0b1f14); border-color: rgba(34,197,94,0.22); }
.toast.error   { background: linear-gradient(145deg, #2a1111, #1a0c0c); border-color: rgba(239,68,68,0.22); }
.toast.warn    { background: linear-gradient(145deg, #241a0b, #1a140a); border-color: rgba(245,158,11,0.22); }
.toast .toast-icon { font-size: 1.05rem; }

/* انتقالات هادئة */
.fade-scale-enter-active, .fade-scale-leave-active { transition: all .22s ease; }
.fade-scale-enter-from, .fade-scale-leave-to { opacity: 0; transform: scale(0.96); }
.toast-fade-enter-active, .toast-fade-leave-active { transition: opacity .22s ease, transform .22s ease; }
.toast-fade-enter-from, .toast-fade-leave-to { opacity: 0; transform: translateY(10px); }

/* دعم النمط الفاتح للمكوّنات */
@media (prefers-color-scheme: light) {
  :root {
    --bg-1: #f6f7fb;
    --bg-2: #ffffff;
    --bg-3: #f1f4f9;
    --text-1: #0e1622;
    --text-2: #4b5563;
    --primary-1: #2f6df6;
    --primary-2: #2154c7;
    --shadow: rgba(0, 0, 0, 0.1);
    --ring: rgba(47, 109, 246, 0.35);
  }
  .popup-backdrop { background: rgba(0,0,0,0.35); }
  .popup-card { border-color: rgba(33,84,199,0.18); }

  /* نافذة التعليمات تبقى نصها أسود أيضاً في النمط الفاتح */
  .arabic-steps {
    background: linear-gradient(180deg, #ffffff, #f2f5fb 65%, #ecf2fc);
    border-color: #dfe9ff;
    color: #000000;
  }
  .arabic-steps h4 { color: #2154c7; }
  .link-box { background: #eef3ff; color: #0e1622; border-color: rgba(33,84,199,0.25); }
}

</style>

